import { lazy } from 'react'

export const PollManagerLayout = lazy(() => import('./layout'))
